import moment from "moment-jalali";
import { Button, Col, Form, Row } from "react-bootstrap";
import SearchableSelect from "../../../Components/SearchableSelect";
import { getUserListASync, referDocument } from "../../../store/api/Users";
import { useState } from "react";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import { Reply } from "react-bootstrap-icons";
import { onDateChange, setErrorDialog, workItemTypesArray } from "../../../store/api/CommonFunctions";
import { getStageUserAndStatusListAsync } from "../../../Office/store/api/FlowAPI";
import { useDispatch } from "react-redux";

export default function NewRefer({ workItem, onReferDone, doRefer }) {
    const { control } = useForm();
    const dispatch = useDispatch();
    const [isPending, setPending] = useState(false);
    const initData = {
        WorkDeadline: workItem.DueDate,
        DocumentGroupHardCode: "WorkItem",
        DocumentHardCode: workItemTypesArray[Number(workItem.Type) - 1],
        DocumentID: workItem.ID,
        Priority: workItem.Priority,
        DeadlineDate: workItem.DueDate ?? new Date(),
        DisplayDate: new Date()
    }
    const [referData, setReferData] = useState({ ...initData });

    //#region functions
    const loadUserOptions = async (qry) => {
        const result = await getStageUserAndStatusListAsync(qry);
        if (Array.isArray(result?.Data?.UserList)) {
            return result.Data.UserList.map(r => ({
                value: r.ID,
                label: r.Name
            }));
        }
        return [];
    }
    const handleUserSelect = (opt) => {
        setReferData(prev => ({
            ...prev,
            UserID: opt?.value,
            UserName: opt?.label
        }));
    };
    const handleDeadline = (value) => {
        setReferData(prev => ({
            ...prev,
            DeadlineDate: value.local("en").format("YYYY/MM/DD HH:mm")
        }))
    }
    const handleSubmit = () => {
        if (isPending) {
            return;
        }
        if(!referData.UserID)
        {
            return;
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ارجاع به کاربر");
                return;
            }
            setPending(false);
            setErrorDialog(dispatch, "success", "ارجاع به کاربر");
            onReferDone?.(referData);
            setReferData({ ...initData });

        }
        if (doRefer)
            referDocument(referData, onSuccess);
        else{
            onReferDone?.(referData);
        }
    }
    const preventEnter = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    }
    //#endregion
    return (
        <Row className="mt-3">
            <Col md={2} className="form-group">
                <label>انتخاب کاربر:</label>
                <SearchableSelect
                    control={control}
                    name="UserID"
                    defaultLabel={referData.UserName ?? ""}
                    placeholder="جستجوی کاربر..."
                    loadOptions={loadUserOptions}
                    onChange={handleUserSelect}
                />
            </Col>
            <Col md={2} className="form-group">
                <label>تاریخ سررسید:</label>
                <DatePicker isGregorian={false} timePicker={true} className="form-control" min={moment()} inputFormat="YYYY-MM-DD HH:mm"
                    onChange={handleDeadline} value={moment(referData.DeadlineDate)} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" />
            </Col>
            <Col className="form-group">
                <label>شرح ارجاع:</label>
                <input type="text" className='form-control'
                    onKeyDown={preventEnter}
                    onChange={e => setReferData({ ...referData, ReferDescription: e.target.value })} value={referData?.ReferDescription ?? ""} />
            </Col>
            <div className="mt-2">
                <Button onClick={handleSubmit} className="group-Btn" disabled={isPending || !referData.UserID}><Reply size={18} /> ارجاع به کاربر</Button>
            </div>
        </Row>
    )
}